import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadMobileAppComponent } from './download-mobile-app.component';

const routes: Routes = [
  {
    path: '**',
    component: DownloadMobileAppComponent,
    data: {
      title: 'Download mobiele app',
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DownloadMobileAppRoutingModule {
}
